
define('text!v3/Common/Components/ResizeableColumntext/ResizeableColumntext.Component.html',[],function () { return '<strong class="extralarge" data-bind="text: extraLarge, tooltip: tooltipOptions"></strong>\r\n<strong class="large" data-bind="text: large, tooltip: tooltipOptions"></strong>\r\n<strong class="medium" data-bind="text: medium, tooltip: tooltipOptions"></strong>\r\n';});

